import XlsExport from 'xlsexport/xls-export'

export default {
  methods: {
    exportChart(type) {
      if (type === 'png') {
        this.$refs.chartComponent.exportChart().then(() => {
          this.$store.dispatch('setSuccess', 'Successfully exported');
        }).catch(() => {
          this.$store.dispatch('setExceptions', 'Something went wrong');
        });
      }
      else {
        let xls = new XlsExport(this.chartData.data, this.chartData.title);
        if (type === 'xls') {
          xls.exportToXLS(`${this.chartData.title}.xls`);
        }
        else {
          xls.exportToCSV(`${this.chartData.title}.csv`);
        }
        this.$store.dispatch('setSuccess', 'Successfully exported');
      }
    },
  }
}
